import { TextField, TextFieldProps } from '@mui/material';
import React, { forwardRef } from 'react';

export type BasicInputProps = TextFieldProps;
const BasicInput = forwardRef<HTMLDivElement, BasicInputProps>(function BasicInput(props: BasicInputProps, ref) {
  return (
    <TextField
      {...props}
      placeholder={props.disabled || props.InputProps?.readOnly ? undefined : props.placeholder}
      ref={ref}
      sx={[
        {
          width: '100%',
          '.MuiOutlinedInput-notchedOutline': {
            borderWidth: 0,
            outline: 0,
          },
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
      inputProps={{
        ...props.inputProps,
        sx: [
          { borderWidth: 0 },
          ...(props.inputProps && Array.isArray(props.inputProps.sx) ? props.inputProps.sx : [props.inputProps?.sx]),
        ],
      }}
      FormHelperTextProps={{
        ...props.FormHelperTextProps,
        sx: [
          ...(props.FormHelperTextProps && Array.isArray(props.FormHelperTextProps.sx)
            ? props.FormHelperTextProps.sx
            : [props.FormHelperTextProps?.sx]),
          { color: theme => theme.palette.error.main },
        ],
      }}
      InputProps={{
        ...props.InputProps,
        sx: [
          {
            outline: 0,
            borderRadius: '15px',
            backgroundColor: _ => (props.error ? 'rgba(248,108,107, 0.1)' : '#f8f8f8'),
          },
          ...(props.InputProps && Array.isArray(props.InputProps.sx) ? props.InputProps.sx : [props.InputProps?.sx]),
        ],
      }}
    />
  );
});

export { BasicInput };
